module.exports = __webpack_public_path__ + "static/sec6-bg-sm-826445cce65b6ca0119af4578ecb7d2d.jpg";